export const PLAN_STATUS_ACTIONS = {
  plan_submit_approve_reject_type: [
    'planned',
    'submitted',
    'rejected',
    'approved',
    'not applicable',
  ],
  plan_inprogress_done_type: [
    'planned',
    'in_progress',
    'done',
    'not applicable',
  ],
  plan_pass_fail_type: ['planned', 'pass', 'fail', 'not applicable'],
  plan_percentage_type: ['planned', 'input_percent'],
}

export const PLAN_STATUS_ACTIONS_UPDATER = {
  plan_submit_approve_reject_type: ['planned', 'submitted'],
  plan_inprogress_done_type: [
    'planned',
    'in_progress',
    'done',
    'not applicable',
  ],
  plan_pass_fail_type: ['planned', 'pass', 'fail', 'not applicable'],
  plan_percentage_type: ['planned', 'input_percent'],
}
